import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCopyright, faHandPointRight, faMailBulk, faMailReply } from "@fortawesome/free-solid-svg-icons";
import { Navbar, Container, Col, Button, ButtonGroup, Carousel, Row } from "react-bootstrap";
import { debounce } from "lodash";
import { faFacebook, faInstagram, faTwitter } from "@fortawesome/free-brands-svg-icons";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import ImageView from "../ImageView";

const Jugendfeuerwehr = () => {

  const [size, setSize] = useState(() => resolveBreakpoint(window.innerWidth));
  const url=process.env.REACT_APP_PUBLIC_BACKEND;
  const recipientEmail = "robinhenke3@web.de";
  const subject = "Webinhalte der Feuerwehr Kubschütz";
  const body = "Vielen Dank";
  const navigate=useNavigate();
  const [ImagePath, setImagePath]=useState([]);  
  const [show, setShow]=useState(null);
 
      const [image, setImg]=useState(null);
      useEffect(() => {
        axios
        .get(
          url+"/image/search/" +
          "$JFalt*" +
            "?page=" +
            0 +
            "&size=" +
            1
        )
        .then((response) => response.data)
        .then((data) => {
            console.log(data.content[0].urls.split(",").slice(1));

            setImagePath({id: data.content[0].id, urls: data.content[0].urls.split(",").slice(2), urlsPage: data.content[0].urls.split(","), description: data.content[0].description});  
        })
        .catch((error) => {
          console.log(error);
        });
        }, []);

  function resolveBreakpoint( width){
    if ( width < 576 ) {
      return 1;
    } else if ( width >= 576 && width < 768 ) {
      return 2;
    } else if ( width >= 768 && width < 992 ) {
      return 2;
    } else if ( width >= 992 && width < 1200 ) {
      return 3;
    } else if ( width >= 1200 && width < 1440 ) {
      return 4;
    } else if ( width >= 1440 ) {
      return 5;
    }
  }
  useEffect(() => {
		const calcInnerWidth = debounce(function () {
			setSize(resolveBreakpoint(window.innerWidth));
		}, 200);
		window.addEventListener('resize', calcInnerWidth);
		return () => window.removeEventListener('resize', calcInnerWidth);
	}, []);

  return (
    <>
    {size>2?(<><br></br><br></br><br></br><br></br></>):null}
    <div id="324" className="ConUni" style={{  position:"relative", textAlign:"center"}}>
        <div id="34522" className="titleMain2" style={{ fontSize:"130%"}}>
            
        {ImagePath.urls?(<img 
                      className=""
                      style={{ position:"center"}}
                      src={url+"/image/image/download/"+ImagePath.id+"/"+ImagePath.urlsPage[0]} 
                      alt={ImagePath.description}
                    />):("Jugendfeuerwehr")}</div>
        
        <div id="672" className="MainParty2" style={{padding:"1%"}}>
       <p>Wir möchten uns hier vorstellen und Euch zeigen was wir so machen. Ihr werdet Bilder von unseren Wettkämpfen und unserer Ausbildung finden und sehen, dass Feuerwehr viel Spass machen kann.</p>
       <p>Die folgende kleine Bildergalerie soll euch zeigen wer wir sind und wie wir uns auf die Gruppenstafette vorbereiten.</p>
       <p>Und vielleicht hat der/die Eine oder Andere von Euch Lust bekommen mal bei uns reinzuschauen. Das könnt ihr gerne tun.</p>
       <p>Jeden zweiten Sonnabend im Monat treffen wir uns von 09:00 bis 11:00 Uhr im Gerätehaus in Kubschütz.</p>
       <p>Nehmt doch Eure Eltern einfach an die Hand und kommt zu uns. <a style={{fontWeight:"bold"}}>Ihr seid herzlich willkommen!</a></p>
       <ImageView
            show={show ? true:false}
            url={url+"/image"}
            img={image}
            id={ImagePath.id}
            onClose={() => setShow(null)} 
          />
        {ImagePath.id?(
            <>
            <Carousel  key={245} indicators={true} pause="hover" interval={null} style={{zIndex:'0'}}>
            {ImagePath.urls.map((mission,index) => {
        if (index % size === 0) {
           const picSlide = ImagePath.urls.slice(index, index + size);
             return (
              <Carousel.Item>
                <Row>
                {picSlide.map((img, i) => (
                    <Col className="cardFokus" key={i} style={{padding:'2%'}} onClick={() => {setShow(true); setImg(img);}}>
                    <img 
                      className="imagestyle caroPicFokus"
                      src={url+"/image/image/download/"+ImagePath.id+"/"+img} style={{maxHeight:'300px'}}
                      alt={ImagePath.description}
                    />
                    </Col>
                  ))}
                </Row> 
              </Carousel.Item>
              );
            }
          })}
            </Carousel>
           </>
          ):(<><br></br><br></br></>)}
        </div></div>  
        <div id="324" className="ConUni" style={{  position:"relative", textAlign:"center"}}>
        <div id="34522" className="titleMain2" style={{ fontSize:"130%", placeItems:"center"}}>
        Online Feuerwehr spielen
        </div>
        <div id="672" className="MainParty2" style={{padding:"1%"}}>
        <p>Hier geht es zum letzten verfügbaren Spiel im Internet, dem „Swissfire - Game“.
Legt schnell die verschiedenen Schläuche, richtet die Strahlrohre aus und löscht das Feuer. Viel Spaß dabei!</p>
<p>Zum Spielen aufs Bild klicken:)</p>    
{ImagePath.urls?(<a href="https://www.cultimedia.ch/swissfire/index-d.html" target="_blank" rel="noopener noreferrer">
          
        <img 
                      className=""
                      style={{ position:"relative"}}
                      src={url+"/image/image/download/"+ImagePath.id+"/"+ImagePath.urlsPage[1]} 
                      alt={ImagePath.description}
                    /></a>):("Jugendfeuerwehr")}
        </div></div> 
         <br></br>
         <br></br>
    </>
  );
};

export default Jugendfeuerwehr;
